package com.sweetlime.dungeonamigo.presentation.features.splash

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.sp
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.navigator.LocalNavigator
import cafe.adriel.voyager.navigator.currentOrThrow
import com.sweetlime.dungeonamigo.presentation.features.auth.AuthScreen
import com.sweetlime.dungeonamigo.presentation.navigation.MainScreen
import com.sweetlime.dungeonamigo.presentation.ui.theme.BrandColors
import com.sweetlime.dungeonamigo.repository.AuthRepository
import kotlinx.coroutines.flow.first
import kotlinx.coroutines.flow.firstOrNull
import kotlinx.coroutines.withTimeoutOrNull
import org.koin.compose.koinInject

class SplashScreen : Screen {
    @Composable
    override fun Content() {
        val navigator = LocalNavigator.currentOrThrow
        val authRepository: AuthRepository = koinInject()

        LaunchedEffect(Unit) {
            // Web: Firebase emits null before restoring session — wait up to 3s.
            val userId = withTimeoutOrNull(3_000) {
                authRepository.authStateChanged().firstOrNull { it != null }
            } ?: authRepository.authStateChanged().first()

            if (userId != null) navigator.replace(MainScreen)
            else navigator.replace(AuthScreen())
        }

        Box(
            modifier = Modifier.fillMaxSize().background(BrandColors.Surface),
            contentAlignment = Alignment.Center
        ) {
            Text(text = "🐉", fontSize = 80.sp)
        }
    }
}
